<div class="section-list card">
    <div class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Users</span>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                    <ul class="nav navbar-nav ml-auto">
                        <li *permusr="controlEnum.BTN_ADMIN_USERS" class="nav-item">
                            <a class="nav-link" role="button" (click)="newElement();false">
                                <i class="far fa-plus-square"></i> New User
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" role="button" (click)="getList();false">
                                <i class="fas fa-sync"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>

    <div class="card-body">
        <div class="">
            <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
            <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

            <table mat-table #table [dataSource]="dataSource" matSort
                class="table table-hover table-striped frms-table table-align-middle">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=""> Name </th>
                    <td mat-cell *matCellDef="let row" >
                        {{row.name}}
                    </td>
                </ng-container>
                <ng-container matColumnDef="surname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=""> Surname </th>
                    <td mat-cell *matCellDef="let row" >
                        {{row.surname}}
                    </td>
                </ng-container>   
                <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=""> Position </th>
                    <td mat-cell *matCellDef="let row" >
                        {{row.info?.position}}
                    </td>
                </ng-container> 
                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class=""> Phone </th>
                    <td mat-cell *matCellDef="let row" >
                        {{uigetphone(row) }}
                    </td>
                </ng-container>                                             
                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>UserName </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.username}}    
                    </td>
                </ng-container>
                <ng-container matColumnDef="modifydate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Last update </th>
                    <td mat-cell *matCellDef="let row">
                        {{row.info?.updating_date | date:'dd-MM-yyyy HH:mm' }}
                    </td>
                </ng-container>             
                <!-- Symbol Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                        <div *permusr="controlEnum.BTN_ADMINISTRATOR" class="td-actions text-right">
                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="openitem(row)">
                                <i class="fas fa-pen"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" [matMenuTriggerFor]="menu">
                                <i class="fas fa-ellipsis-v"></i>
                            </button>
                            <mat-menu #menu="matMenu" class="">
                                <div mat-menu-item>
                                    <a class="dropdown-item text-danger" (click)="openDialogDeleteUser(row)"
                                        matTooltip="Delete user">
                                        <i class="far fa-trash-alt"></i> Delete</a>
                                </div>
                            </mat-menu>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true" class="thead-dark"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openitem(row)"></tr>
                <!--                 <mat-row *matRowDef="let row; columns: displayedColumns;" 
          (click)="highlightedRows.push(row)"
          [style.background]="highlightedRows.indexOf(row) != -1 ? 'lightblue' : ''"></mat-row> -->
            </table>
            <mat-paginator [pageSizeOptions]="[20,50,100,200]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>